import React, { FC }                   from 'react';
import { Label, List, SemanticCOLORS } from 'semantic-ui-react';
import _                               from 'underscore';

import { ProjectService, TimeService }    from '../../../../services';
import { CorvalProjectActivity }          from '../../../../types';
import { ProjectTimelineDateFieldObject } from '../../../../services/ProjectService';

interface Props {
	projectTimelineFields: ProjectTimelineDateFieldObject[],
	projectActivity: CorvalProjectActivity
}

const defaultProps: Props = {
	projectTimelineFields: [],
	projectActivity:       null,
}

const ProjectActivityDetailsRecurrenceMilestoneList: FC<Props> = ( { projectActivity, projectTimelineFields } ) => {
	
	return (
		<List className={ 'no-padding-horizontal' }>
			
			{ ProjectService.getProjectActivityRecurrenceMilestones( projectActivity, true ).map( milestoneIdentifier => {
				
				let isCustomMilestone = ProjectService.isCustomMilestoneDefinitionId( milestoneIdentifier ),
				    fieldId           = !isCustomMilestone ? ProjectService.getMilestoneInfoFromType( milestoneIdentifier )?.PROJECT_FIELD ?? null : milestoneIdentifier,
				    milestone         = _.findWhere( projectTimelineFields, { fieldId } );
				
				if( !milestone ) return null;
				
				let milestoneLabelTerm         = milestone.label,
				    milestoneDate              = TimeService.ISOtoMoment( milestone.value ),
				    startDate                  = TimeService.ISOtoMoment( projectActivity.startTimeUtc ),
				    milestoneRecurrenceIgnored = milestoneDate.isSameOrBefore( startDate );
				
				return (
					
					<List.Item>
						<Label circular color={ milestoneRecurrenceIgnored ? 'grey' : isCustomMilestone ? 'orange' : 'purple' as SemanticCOLORS }
						       icon={ { name: 'calendar alternate outline' } }
						       content={ milestoneLabelTerm }/>
					</List.Item>
				
				)
				
			} ) }
		
		</List>
	);
};

ProjectActivityDetailsRecurrenceMilestoneList.defaultProps = defaultProps;

export { ProjectActivityDetailsRecurrenceMilestoneList }
